import { render, staticRenderFns } from "./VariableFormatSelector.vue?vue&type=template&id=3c67324a"
import script from "./VariableFormatSelector.vue?vue&type=script&lang=js"
export * from "./VariableFormatSelector.vue?vue&type=script&lang=js"
import style0 from "./VariableFormatSelector.vue?vue&type=style&index=0&id=3c67324a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports